import { IUserProfileFields } from '../../lib/interfaces/User';

type UserProfileFieldsType = {
	name: keyof IUserProfileFields;
	label: string;
	disabled?: boolean;
	validation: {
		required?: boolean;
		maxLength?: number;
		minLength?: number;
		forbidSpecialCharacters?: boolean;
		forbidSpecialCharactersForName?: boolean;
	};
};

export const getUserProfileFields = (
	t: (s: string) => string,
): UserProfileFieldsType[] => [
	{
		name: 'firstName',
		label: t('firstName'),
		validation: {
			required: true,
			maxLength: 40,
			minLength: 2,
			forbidSpecialCharactersForName: true,
		},
	},
	{
		name: 'lastName',
		label: t('lastName'),
		validation: {
			required: true,
			maxLength: 40,
			minLength: 2,
			forbidSpecialCharactersForName: true,
		},
	},
	{
		name: 'email',
		label: t('email'),
		disabled: true,
		validation: {
			required: true,
			maxLength: 40,
		},
	},
	{
		name: 'company',
		label: t('company'),
		validation: {
			required: false,
			maxLength: 40,
			minLength: 2,
			forbidSpecialCharactersForName: true,
		},
	},
	{
		name: 'position',
		label: t('position'),
		validation: {
			required: false,
			maxLength: 40,
			minLength: 2,
			forbidSpecialCharactersForName: true,
		},
	},
];
